<form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
  <h1 class="form-title">Contact us</h1>
  <div class="form-title-underline"></div>
  <div class="contact-form-row">
    <div class="contact-form-group">
      <app-input
        id="firstname"
        [label]="'contact-page.firstName.title' | translate"
        formControlName="firstname"
        placeholder="{{ 'contact-page.firstName.placeholder' | translate }}"
      />

      <div
        class="contact-error"
        *ngIf="submitted && this.f['firstname'].invalid"
      >
        {{ "contact-page.firstName.errorMessage" | translate }}
      </div>
    </div>

    <div class="contact-form-group">
      <app-input
        id="lastname"
        [label]="'contact-page.lastName.title' | translate"
        formControlName="lastname"
        placeholder="{{ 'contact-page.lastName.placeholder' | translate }}"
      />

      <div
        class="contact-error"
        *ngIf="submitted && this.f['lastname'].invalid"
      >
        {{ "contact-page.lastName.errorMessage" | translate }}
      </div>
    </div>
  </div>

  <div class="contact-form-row">
    <div class="contact-form-group">
      <app-input
        id="email"
        type="email"
        [label]="'contact-page.email.title' | translate"
        formControlName="email"
        placeholder="{{ 'contact-page.email.placeholder' | translate }}"
      />

      <div class="contact-error" *ngIf="submitted && this.f['email'].invalid">
        {{ "contact-page.email.errorMessage" | translate }}
      </div>
    </div>

    <div class="contact-form-group">
      <app-input
        id="phone"
        type="tel"
        [label]="'contact-page.phoneNumber.title' | translate"
        formControlName="phone"
        placeholder="{{ 'contact-page.phoneNumber.placeholder' | translate }}"
      />

      <div class="contact-error" *ngIf="submitted && this.f['phone'].invalid">
        {{ "contact-page.phoneNumber.errorMessage" | translate }}
      </div>
    </div>
  </div>

  <div class="contact-form-row">
    <div class="contact-form-group full-width">
      <app-dropdown
        formControlName="subject"
        [label]="'contact-page.subject.title' | translate"
        [options]="subject"
        [placeholder]="'contact-page.subject.placeholder' | translate"
      />

      <div class="contact-error" *ngIf="submitted && this.f['subject'].invalid">
        {{ "contact-page.subject.errorMessage" | translate }}
      </div>
    </div>
  </div>

  <div class="contact-form-row">
    <div class="contact-form-group full-width">
      <app-textarea
        formControlName="message"
        [label]="'contact-page.message.title' | translate"
        [rows]="6"
        placeholder="{{ 'contact-page.message.placeholder' | translate }}"
        [maxLength]="1000"
      ></app-textarea>

      <div class="contact-error" *ngIf="submitted && this.f['message'].invalid">
        {{ "contact-page.message.errorMessage" | translate }}
      </div>
    </div>
  </div>

  <app-button
    class="submit-btn"
    [label]="'contact-page.buttonText' | translate"
    type="submit"
  />
</form>
